import React from "react"
import DropdownButton from "react-bootstrap/lib/DropdownButton"
import MenuItem from "react-bootstrap/lib/MenuItem"

import style from "./index.module.sass"

import { ORDERING } from "../../OrderByList"

// ----------------------------------------------------------------------------

function DropDownSorting(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { sortFunction, handleSort = () => {} } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  return (
    <div className={`${style.orderByContainer} hidden-xs filters-dropdown`}>
      <DropdownButton
        bsStyle={"default"}
        title={I18n.t(`service_ordering.ordering_title`)}
        id={`dropdown-basic`}
      >
        {ORDERING.map((el, index) => {
          return (
            <MenuItem key={`menu-item-${index}`} eventKey={index + 1}>
              <div
                key={`ordb-${index}`}
                className={`${style.element} ${
                  el.title === sortFunction?.title ? style.selected : ""
                }`}
                onClick={() => handleSort(el)}
              >
                {I18n.t(`service_ordering.ordering_method.${el.title}`)}
              </div>
            </MenuItem>
          )
        })}
        {
          <MenuItem eventKey="3">
            <div
              style={{ visibility: !!sortFunction ? "visible" : "hidden" }}
              className={style.element}
              onClick={() => handleSort(null)}
            >
              {I18n.t(`service_ordering.ordering_method.reset`)}
            </div>
          </MenuItem>
        }
      </DropdownButton>
    </div>
  )
}

// ----------------------------------------------------------------------------

export default DropDownSorting
